import { forwardRef } from 'react';

import { cn } from '@/lib/utils';

const Select = forwardRef(({ className, children, ...props }, ref) => {
  return (
    <select
      ref={ref}
      className={cn(
        'flex h-10 px-3 py-2 w-full',
        'bg-background border border-input ring-offset-background rounded-md disabled:cursor-not-allowed disabled:opacity-50',
        'text-base placeholder:text-muted-foreground md:text-sm',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-ring',
        className
      )}
      {...props}
    >
      {children}
    </select>
  );
});

Select.displayName = 'Select';

export { Select };
